import getEnvVars from '../../../environments';
import { Analytics, Event, PageHit } from 'expo-analytics';
import Constants from 'expo-constants';

export enum GaCategories {
  SPOTIFY = 'Spotify',
  SIGNIN = 'SignIn',
  SIGNUP = 'SignUp',
  SESSION = 'Session',
  SIGNOUT = 'SignOut',
}

export enum GaActions {
  LISTEN = 'Listen',
  PLAY = 'Play',
  PAUSED = 'Paused',
  FINISH = 'Finish Listen',
  NEXT = 'Next Track',
  CREATE = 'Create',
  SIGNIN = 'Sign In',
}

class AppAnalytics {
  private debug;
  private gaTrackingId;
  private analytics;
  private analyticsLabel;
  private checkForAnalyticsId;

  constructor() {
    this.debug = Constants.manifest.extra.environment !== 'beta';
    this.gaTrackingId = getEnvVars().gaTrackingId;
    this.analytics = new Analytics(this.gaTrackingId);
    this.analyticsLabel =
      Constants.manifest.extra.environment === 'beta'
        ? 'production'
        : 'development';
    this.checkForAnalyticsId = function () {
      let analyticsIdExists = true;
      if (!this.gaTrackingId) {
        console.error('No Google Analytics Tracking ID set');
        analyticsIdExists = false;
      }
      return analyticsIdExists;
    };
  }

  sendEvent(category: string, action: string, eventValue: number) {
    if (!this.checkForAnalyticsId()) return;
    this.analytics
      .event(new Event(category, action, this.analyticsLabel, eventValue))
      .then(
        () =>
          this.debug && console.info(`Event Data: ${category} and ${action}`),
      )
      .catch(
        (e) =>
          this.debug &&
          console.error(
            `Event Data error: ${category} and ${action} - ${e.message}`,
          ),
      );
  }

  sendPageHit(pageName: string) {
    if (!this.checkForAnalyticsId()) return;
    this.analytics
      .hit(new PageHit(pageName))
      .then(() => this.debug && console.info(`Page Hit success: ${pageName}`))
      .catch(
        (e) =>
          this.debug &&
          console.error(`Page Hit error: ${pageName} ${e.message}`),
      );
  }

  // sendTimestampStart(startTime: string) {
  //     if (!gaTrackingId) return;
  //     const dateTime = new Date();
  //     if (debug) {
  //       console.info('Date Time (debug mode): ', dateTime);
  //     } else {
  //       analytics.addCustomMetric(1, dateTime);
  //     }
  // }
}
const instance = new AppAnalytics();
export default instance;
